import { render, staticRenderFns } from "./VxCellPaymentCountryCheckbox.vue?vue&type=template&id=12ab7074&"
import script from "./VxCellPaymentCountryCheckbox.vue?vue&type=script&lang=js&"
export * from "./VxCellPaymentCountryCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports